import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  pressable: {
    width: '100%',
    height: '100%',
    padding: theme.spacings.md,
  },
  card: {
    backgroundColor: theme.colors.white,
    height: '100%',
    width: '100%',
    borderRadius: theme.borderRadii['3xl'],
  },
  labelWrapper: {
    padding: theme.spacings.sm,
    position: 'absolute',
    bottom: theme.spacings.sm,
    left: 0,
    right: 0,
  },
  image: {
    width: '100%',
    flex: 1,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelText: {
    textAlign: 'center',
  },
  badge: {
    position: 'absolute',
  },
});
